export default "__VITE_ASSET__CdTfy9ox__"